//------------------------REACT ESSENTIALS------------------------//
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

// ------------------------ COMPONENTS ------------------------//
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import { convertedColumnName, getTableColumns, noRowsTemplate } from "../../common";
import { DataGrid, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarColumnsButton } from "@mui/x-data-grid";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import moment from "moment";

// ------------------------ REDUX ------------------------//
import { useDispatch, useSelector } from "react-redux";
import { getAreaGroupList, getMainEquipmentList, getSubEquipmentList, getSubEquipmentsTaskList, getBreakDownReasonGroupData, getBreakdownReasonPlaceData, getBreakdownEffectData, getBreakdownRootCauseData, getPoolData  } from "../../store/actions/MachineMaintenanceSummaryListActions";

// ------------------------ STYLES ------------------------//
import { Collapse, Grow, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import LinearProgress from '@mui/material/LinearProgress';
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import FilterButton from "../../components/FilterButton/FilterButton";

const useStyles = makeStyles((_theme) => ({
    areaTableCellStyle: {
        backgroundColor: "rgb(198,218,214)",
        color: "black"
    },
    mainEquipmentTableCellStyle: {
        backgroundColor: "#EAF2E8",
        color: "black"
    },
    subEquipmentTableCellStyle: {
        backgroundColor: "#f6f9f5",
        color: "black"
    },
    taskTableCellStyle: {
        backgroundColor: "aliceblue",
        width: "2160px",
        color: "black"
    },
    expandArrowStyle: {
        color:"#3C9CC0"
    }
}));

export default function MachineMaintenanceSummaryList(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [sortItem, setSortItem] = useState(null);

    const { areaGroupList, mainEquipmentList, subEquipmentList, subEquipmentsTaskList, breakdownReasonGroupData, breakdownReasonPlaceData, breakdownEffectData, breakdownRootCauseData, poolData  } = useSelector(({ MachineMaintenanceSummaryList }) => MachineMaintenanceSummaryList);

    const [areaGroupData, setAreaGroupData] = useState([]);
    const [mainEquipmentData, setMainEquipmentData] = useState([]);
    const [subEquipmentData, setSubEquipmentData] = useState([]);
    const [subEqTaskList, setsubEqTaskList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        areaGroupList?.resultObject ? setAreaGroupData(areaGroupList.resultObject) : setAreaGroupData([]);
    }, [areaGroupList]);

    useEffect(() => {
        mainEquipmentList?.resultObject ? setMainEquipmentData(mainEquipmentList.resultObject) : setMainEquipmentData([]);
    }, [mainEquipmentList]);

    useEffect(() => {
        subEquipmentList?.resultObject ? setSubEquipmentData(subEquipmentList.resultObject) : setSubEquipmentData([]);
    }, [subEquipmentList]);

    useEffect(() => {
        subEquipmentsTaskList?.resultObject ? setsubEqTaskList(subEquipmentsTaskList.resultObject) : setsubEqTaskList([]);
        setLoading(false);
    }, [subEquipmentsTaskList]);

    
    //load area data first
    useEffect(() => {
        const data = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
            ...state
          }
        
        
        dispatch(getBreakDownReasonGroupData());
        dispatch(getBreakdownReasonPlaceData());
        dispatch(getBreakdownEffectData());
        dispatch(getBreakdownRootCauseData());
        dispatch(getPoolData());
        dispatch(getAreaGroupList(data));
    }, [dispatch]);

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (columnName) => {
        setSortItem({
            ...sortItem,
            propertyName: convertedColumnName(columnName), //Added to convert column name like "id" to "Id" because of sorting on backend-side
            direction: sortItem?.propertyName === convertedColumnName(columnName) ? invertSortDirection(sortItem?.direction) : 0,
        });
    };

    const invertSortDirection = (direction) => (direction === 0 ? 1 : 0);

    // AREA GROUP PAGINATION
    const [areaGroupCurrentPage, setAreaGroupCurrentPerPage] = useState(0);
    const [areaGrouprowsPerPage, setAreaGroupRowsPerPage] = useState(10);
    const areaGroupHandleChangePage = (_event, newPage) => {
        setAreaGroupCurrentPerPage(newPage);
    };

    const areaGroupHandleChangeRowsPerPage = (event) => {
        setAreaGroupRowsPerPage(+event.target.value);
        setAreaGroupCurrentPerPage(0);
    };

    // MAIN EQUIPMENT PAGINATION
    const [mainEquipmentCurrentPage, setMainEquipmentCurrentPerPage] = useState(0);
    const [mainEquipmentRowsPerPage, setMainEquipmentRowsPerPage] = useState(10);
    const mainEquipmentHandleChangePage = (_event, newPage) => {
        setMainEquipmentCurrentPerPage(newPage);
    };

    const mainEquipmentHandleChangeRowsPerPage = (event) => {
        setMainEquipmentRowsPerPage(+event.target.value);
        setMainEquipmentCurrentPerPage(0);
    };

    // SUB EQUIPMENT PAGINATION
    const [subEquipmentCurrentPage, setSubEquipmentCurrentPerPage] = useState(0);
    const [subEquipmentRowsPerPage, setSubEquipmentRowsPerPage] = useState(10);
    const subEquipmentHandleChangePage = (_event, newPage) => {
        setSubEquipmentCurrentPerPage(newPage);
    };

    const subEquipmentHandleChangeRowsPerPage = (event) => {
        setSubEquipmentRowsPerPage(+event.target.value);
        setSubEquipmentCurrentPerPage(0);
    };

    // TASKS'S 
    
    const [tasksCurrentPage, setTasksCurrentPerPage] = useState(0);
    const [tasksRowsPerPage, setTasksRowsPerPage] = useState(10);
    const tasksHandleChangePage = (event) => {
        setTasksCurrentPerPage(event);
    };

    const tasksHandleChangeRowsPerPage = (event) => {
        setTasksRowsPerPage(+event);
        setTasksCurrentPerPage(0);
    };

    //EXPAND AREA GROUP ROW
    const [openAreaRow, setOpenAreaRow] = useState(false);
    const [expandAreaID, setExpandAreaId] = useState(0);
    const expandAreaRow = (row) => {
        if (openAreaRow && expandAreaID !== row) {
            setExpandAreaId(row);
        } else {
            setOpenAreaRow(!openAreaRow);
            setExpandAreaId(row);
        }

        if (!openAreaRow) {
            setMainEquipmentData([]);
            setOpenMainEquipmentRow(false);
            setOpenSubEquipmentRow(false);
        }

        const data = {
            equipmentId: 0,
            areaId: row,
            mainEquipmentId: 0,
            ...state
        }

        dispatch(getMainEquipmentList(data));
    };

    //EXPAND MAIN EQUIPMENT ROW
    const [openMainEquipmentRow, setOpenMainEquipmentRow] = useState(false);
    const [expandMainEquipmentID, setExpandMainEquipmentId] = useState(0);
    const expandMainEquipmentRow = (rowId) => {
        if (openMainEquipmentRow && expandMainEquipmentID !== rowId.mainEquipmentId) {
            setExpandMainEquipmentId(rowId.mainEquipmentId);
        } else {
            setOpenMainEquipmentRow(!openMainEquipmentRow);
            setExpandMainEquipmentId(rowId.mainEquipmentId);
        }

        if (!openMainEquipmentRow) {
            setSubEquipmentData([]);
            setOpenSubEquipmentRow(false);
        }

        const data = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: rowId.mainEquipmentId,
            ...state
        }
        dispatch(getSubEquipmentList(data));
    };

    //EXPAND SUB EQUIPMENT ROW
    const [openSubEquipmentRow, setOpenSubEquipmentRow] = useState(false);
    const [expandSubEquipmentID, setExpandSubEquipmentID] = useState(0);
    const expandSubEquipmentRow = (rowId) => {
        if (openSubEquipmentRow && expandSubEquipmentID !== rowId.equipmentId) {
            setExpandSubEquipmentID(rowId.equipmentId);
        } else {
            setOpenSubEquipmentRow(!openSubEquipmentRow);
            setExpandSubEquipmentID(rowId.equipmentId);
        }
        setsubEqTaskList([]);
        setLoading(true);

        const data = {
            equipmentId: rowId.equipmentId,
            areaId: 0,
            mainEquipmentId: 0,
            ...state
        }
        dispatch(getSubEquipmentsTaskList(data));
    };

    const NavigateToDetails = (id) => {
        sessionStorage.setItem("blt_pushBreakdownDetail", tasksCurrentPage);
        sessionStorage.setItem("blt_rowsPerPage", tasksRowsPerPage);
        history.push("/breakdowndetail?id=" + id);
    };

    const renderTableCell = (rowItems) => {
        return rowItems.map((item) => {
            return <TableCell align="center" id={`mmsl_TableHead_${item.id}`}>{item.label}</TableCell>;
        });
    };

    const columnVisibilityModelData = JSON.parse(localStorage.getItem("columnVisibilityModelU")) || {};
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(columnVisibilityModelData);

    const customToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarDensitySelector />
                <GridToolbarColumnsButton name="column" />
                {/* <GridToolbarFilterButton /> */}
            </GridToolbarContainer>
        );
    };

    const handleChangeVisibility = (newModel) => {
        setColumnVisibilityModel(newModel);
        localStorage.setItem("columnVisibilityModelU", JSON.stringify(newModel));
    };

    
    const initialState = {
        breakdownReasonGroupIds: JSON.parse(sessionStorage.getItem("mmsu_breakdownReasonGroupIds")) || [],
        breakdownEffectIds: JSON.parse(sessionStorage.getItem("mmsu_breakdownEffectIds")) || [],
        breakdownReasonPlaceIds: JSON.parse(sessionStorage.getItem("mmsu_breakdownReasonPlaceIds")) || [],
        breakdownRootCauseIds: JSON.parse(sessionStorage.getItem("mmsu_breakdownRootCauseIds")) || [],
        poolIds: JSON.parse(sessionStorage.getItem("mmsu_poolIds")) || [],
    };

    const [state, setState] = useState({ ...initialState });
    const [breakdownReasonGroupDataF, setBreakdownReasonGroupDataF] = useState([]);
    const [breakdownReasonPlaceDataF, setBreakdownReasonPlaceDataF] = useState([]);
    const [breakdownEffectDataF, setBreakdownEffectDataF] = useState([]);
    const [breakdownRootCauseDataF, setBreakdownRootCauseDataF] = useState([]);
    const [poolDataF, setPoolDataF] = useState([]);

    const setDefaultState = () => {
        setState({
            breakdownReasonGroupIds:  [],
            breakdownEffectIds:  [],
            breakdownReasonPlaceIds: [],
            breakdownRootCauseIds:  [],
            poolIds:  [],
        });
    };

    
    useEffect(() => {
        setBreakdownReasonGroupDataF(breakdownReasonGroupData)
    }, [breakdownReasonGroupData]);

    useEffect(() => {
        setBreakdownReasonPlaceDataF(breakdownReasonPlaceData)
    }, [breakdownReasonPlaceData]);

    useEffect(() => {
        setBreakdownEffectDataF(breakdownEffectData)
    }, [breakdownEffectData]);
    
    useEffect(() => {
        setBreakdownRootCauseDataF(breakdownRootCauseData)
    }, [breakdownRootCauseData]);

    useEffect(() => {
        setPoolDataF(poolData)
    }, [poolData]);


    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }

        setIsFilterDrawerOpen(open);
    };

    
    const HandleClearFilter = () => {
       
        setDefaultState();
        const dataArea = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
        }
        dispatch(getAreaGroupList(dataArea));

        if(expandSubEquipmentID !== 0){
            const dataSubEquipTask = {
                equipmentId: expandSubEquipmentID,
                areaId: 0,
                mainEquipmentId: 0,
            }
            dispatch(getSubEquipmentsTaskList(dataSubEquipTask));
        }

        if(expandAreaID !== 0){
            const dataMain = {
                equipmentId: 0,
                areaId: expandAreaID,
                mainEquipmentId: 0,
            }

            dispatch(getMainEquipmentList(dataMain));
        }

        if(expandMainEquipmentID !== 0){
            const dataSubEquip = {
                equipmentId: 0,
                areaId: 0,
                mainEquipmentId: expandMainEquipmentID,
            }
     
            dispatch(getSubEquipmentList(dataSubEquip));
        }


        sessionStorage.setItem("mmsu_breakdownRootCauseIds", JSON.stringify([]));
        sessionStorage.setItem("mmsu_breakdownReasonPlaceIds", JSON.stringify([]));
        sessionStorage.setItem("mmsu_breakdownEffectIds", JSON.stringify([]));
        sessionStorage.setItem("mmsu_breakdownReasonGroupIds", JSON.stringify([]));
        sessionStorage.setItem("mmsu_poolIds", JSON.stringify([]));
        sessionStorage.setItem("mmsu_startDate", JSON.stringify(Date.now()));
        sessionStorage.setItem("mmsu_endDate", JSON.stringify(Date.now()));

    };

    const HandleApplyFilter = () => {
        const dataArea = {
            equipmentId: 0,
            areaId: 0,
            mainEquipmentId: 0,
            ...state
        }
        dispatch(getAreaGroupList(dataArea));

        if(expandSubEquipmentID !== 0){
            const dataSubEquipTask = {
                equipmentId: expandSubEquipmentID,
                areaId: 0,
                mainEquipmentId: 0,
                ...state
            }
            dispatch(getSubEquipmentsTaskList(dataSubEquipTask));
        }

        if(expandAreaID !== 0){
            const dataMain = {
                equipmentId: 0,
                areaId: expandAreaID,
                mainEquipmentId: 0,
                ...state
            }

            dispatch(getMainEquipmentList(dataMain));
        }

        if(expandMainEquipmentID !== 0){
            const dataSubEquip = {
                equipmentId: 0,
                areaId: 0,
                mainEquipmentId: expandMainEquipmentID,
                ...state
            }
     
            dispatch(getSubEquipmentList(dataSubEquip));
        }
        toggleDrawer(false);
        setIsFilterDrawerOpen(false);       
    };

      // Set breakdown reason group
    const HandleBreakdownReasonGroup = (breakdownReasonGroupIds) => {
        let ids = [];
        breakdownReasonGroupIds.map((item) => ids.push(item.id));
        if (breakdownReasonGroupIds == null) {
            sessionStorage.removeItem("mmsu_breakdownReasonGroupIds");
        } else {
            sessionStorage.setItem("mmsu_breakdownReasonGroupIds", JSON.stringify(ids));
        }
        setState({ ...state, breakdownReasonGroupIds: ids });
    };

    const HandleBreakdownEffect = (breakdownEffectIds) => {
        let ids = [];
        breakdownEffectIds.map((item) => ids.push(item.id));
        if (breakdownEffectIds == null) {
            sessionStorage.removeItem("mmsu_breakdownEffectIds");
        } else {
            sessionStorage.setItem("mmsu_breakdownEffectIds", JSON.stringify(ids));
        }
        setState({ ...state, breakdownEffectIds: ids });
    };

    const HandleBreakdownReasonPlace = (breakdownReasonPlaceIds) => {
        let ids = [];
        breakdownReasonPlaceIds.map((item) => ids.push(item.id));
        if (breakdownReasonPlaceIds == null) {
            sessionStorage.removeItem("mmsu_breakdownReasonPlaceIds");
        } else {
            sessionStorage.setItem("mmsu_breakdownReasonPlaceIds", JSON.stringify(ids));
        }
        setState({ ...state, breakdownReasonPlaceIds: ids });
    };

    const HandleBreakdownRootCause = (breakdownRootCauseIds) => {
        let ids = [];
        breakdownRootCauseIds.map((item) => ids.push(item.id));
        if (breakdownRootCauseIds == null) {
            sessionStorage.removeItem("mmsu_breakdownRootCauseIds");
        } else {
            sessionStorage.setItem("mmsu_breakdownRootCauseIds", JSON.stringify(ids));
        }
        setState({ ...state, breakdownRootCauseIds: ids });
    };

    const HandlePool = (poolIds) => {
        let ids = [];
        poolIds.map((item) => ids.push(item.id));
        if (poolIds == null) {
            sessionStorage.removeItem("mmsu_poolIds");
        } else {
            sessionStorage.setItem("mmsu_poolIds", JSON.stringify(ids));
        }
        setState({ ...state, poolIds: ids });
    };

    const HandleStartDate = (startDate) => {
        if (startDate == null) {
            sessionStorage.removeItem("mmsu_startDate");
        } else {
            sessionStorage.setItem("mmsu_startDate", JSON.stringify(startDate));
        }
        startDate = moment(startDate).format("YYYY-MM-DD")
        setState({ ...state, createdDate : {
            ...state.createdDate,startDate
        } });

    };

    const HandleEndDate = (endDate) => {
        if (endDate == null) {
            sessionStorage.removeItem("mmsu_endDate");
        } else {
            sessionStorage.setItem("mmsu_endDate", JSON.stringify(endDate));
        }
        endDate = moment(endDate).format("YYYY-MM-DD")
        setState({ ...state, createdDate : {
            ...state.createdDate,endDate
        } });

    };

    const filter = () => {
        return (
            <DetailFilter
                HandleBreakdownEffect={HandleBreakdownEffect}
                HandleBreakdownReasonGroup={HandleBreakdownReasonGroup}
                HandleBreakdownReasonPlace={HandleBreakdownReasonPlace}
                HandleBreakdownRootCause={HandleBreakdownRootCause}
                HandlePool={HandlePool}
                breakdownEffect={state.breakdownEffectIds}
                breakdownReasonGroup={state.breakdownReasonGroupIds}
                breakdownReasonPlace={state.breakdownReasonPlaceIds}
                breakdownRootCause={state.breakdownRootCauseIds}
                poolIds={state.poolIds}
                breakdownEffectData={breakdownEffectDataF}
                breakdownReasonGroupData={breakdownReasonGroupDataF}
                breakdownReasonPlaceData={breakdownReasonPlaceDataF}
                breakdownRootCauseData={breakdownRootCauseDataF}
                poolData={poolDataF}
                HandleStartDate={HandleStartDate}
                startDate={state.createdDate?.startDate || null}
                HandleEndDate={HandleEndDate}
                endDate={state.createdDate?.endDate || null}
                isAreaNotFiltered={true}
            />
        );
    };
 
    return (
        <StyledTableDiv>
              <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={HandleApplyFilter}
                detailFilter={filter()}
            />
            <FilterButton onClick={() => toggleDrawer(true)} />
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" className={classes.areaTableCellStyle}>
                        <TableHead>
                            <TableRow>
                                {renderTableCell([
                                    { id: "", label: "" },
                                    { id: "areaName", label: t("Area") },
                                    { id: "areaGroupTaskCount", label: t("UnPlannedTotalTaskCount") },
                                    { id: "areaGroupAvgStartDuration", label: t("UnPlannedAverageStartingTime") },
                                    { id: "areaGroupAvgMaintDuration", label: t("UnPlannedAverageCompletionTime") },
                                    { id: "areaGroupMTTR", label: t("UnPlannedMTTR") },
                                ])}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {areaGroupData.slice(areaGroupCurrentPage * areaGrouprowsPerPage, areaGroupCurrentPage * areaGrouprowsPerPage + areaGrouprowsPerPage).map((row, rowIndex) => (
                                <React.Fragment>
                                    <TableRow id={`mmsl_TableRow_1_${rowIndex}`} key={row.id} className={classes.areaTableCellStyle}>
                                        <TableCell id={`mmsl_TableCell_1_expand`} style={{ padding: 0 }} className={classes.areaTableCellStyle}>
                                            <IconButton id={`mmsl_IconButton_${rowIndex}`} className={classes.expandArrowStyle} aria-label="expand row" size="small" onClick={() => expandAreaRow(row.areaId)}>
                                                {openAreaRow && expandAreaID === row.areaId ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                            </IconButton>
                                        </TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle} style={{ padding: 0 }}>
                                            {row.areaName}
                                        </TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{row.areaGroupTaskCount}</TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{Math.round(row.areaAvgStartDuration)}</TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{Math.round(row.areaAvgMaintDuration)}</TableCell>
                                        <TableCell align="center" className={classes.areaTableCellStyle}>{Math.round(row.mttr)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        {expandAreaID === row.areaId ? (
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                <Collapse in={openAreaRow} timeout="auto" unmountOnExit>
                                                    <TableContainer component={Paper}>
                                                        <Table size="small" className={classes.mainEquipmentTableCellStyle}>
                                                            <TableHead>
                                                                <TableRow id={`mmsl_TableRow_2_${rowIndex}`}>
                                                                    {renderTableCell([
                                                                        { id: "", label: "" },
                                                                        { id: "mainEquipmentName", label: t("MainEquipment") },
                                                                        { id: "unPlannedTaskCount", label: t("UnPlannedTotalTaskCount") },
                                                                        
                                                                        { id: "unPlannedAvgStartDuration", label: t("UnPlannedAverageStartingTime") },
                                                                        { id: "unPlannedAvgMaintDuration", label: t("UnPlannedAverageCompletionTime") },
                                                                        { id: "mttr", label: t("UnPlannedMTTR") },
                                                                    ])}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {mainEquipmentData
                                                                    .slice(
                                                                        mainEquipmentCurrentPage * mainEquipmentRowsPerPage,
                                                                        mainEquipmentCurrentPage * mainEquipmentRowsPerPage + mainEquipmentRowsPerPage
                                                                    )
                                                                    .map((row, itemIndex) => (
                                                                        <React.Fragment>
                                                                            <TableRow id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} key={row.id} className={classes.mainEquipmentTableCellStyle}>
                                                                                <TableCell id={`cig_TableCell_1_expand`}>
                                                                                    <IconButton
                                                                                        className={classes.expandArrowStyle}
                                                                                        id={`mmsl_IconButton_${rowIndex}`}
                                                                                        aria-label="expand row"
                                                                                        size="small"
                                                                                        onClick={() => expandMainEquipmentRow(row)}
                                                                                    >
                                                                                        {openMainEquipmentRow && expandMainEquipmentID === row.mainEquipmentId ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                                                                    </IconButton>
                                                                                </TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center" style={{}}>
                                                                                    {row.mainEquipmentName}
                                                                                </TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{row.mainEquipmentTaskCount}</TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{Math.round(row.mainEquipmentAvgStartDuration)}</TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{Math.round(row.mainEquipmentAvgMaintDuration)}</TableCell>
                                                                                <TableCell id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`} className={classes.mainEquipmentTableCellStyle} align="center">{Math.round(row.mttr)}</TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                {expandMainEquipmentID === row.mainEquipmentId ? (
                                                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                                                        <Collapse in={openMainEquipmentRow} timeout="auto" unmountOnExit>
                                                                                            <TableContainer component={Paper}>
                                                                                                <Table size="small" className={classes.subEquipmentTableCellStyle}>
                                                                                                    <TableHead>
                                                                                                        <TableRow id={`mmsl_TableRow_2_${rowIndex}`}>
                                                                                                            {renderTableCell([
                                                                                                                { id: "", label: "" },
                                                                                                                { id: "subEquipmnetName", label: t("SubEquipment") },
                                                                                                                { id: "unPlannedTaskCount", label: t("UnPlannedTotalTaskCount") },
                                                                                                                { id: "unPlannedAvgStartDuration", label: t("UnPlannedAverageStartingTime") },
                                                                                                                { id: "unPlannedAvgMaintDuration", label: t("UnPlannedAverageCompletionTime") },
                                                                                                                { id: "mttr", label: t("UnPlannedMTTR") },
                                                                                                            ])}
                                                                                                        </TableRow>
                                                                                                    </TableHead>
                                                                                                    <TableBody>
                                                                                                        {subEquipmentData
                                                                                                            .slice(
                                                                                                                subEquipmentCurrentPage * subEquipmentRowsPerPage,
                                                                                                                subEquipmentCurrentPage * subEquipmentRowsPerPage + subEquipmentRowsPerPage
                                                                                                            )
                                                                                                            .map((row, itemIndex) => (
                                                                                                                <React.Fragment>
                                                                                                                    <TableRow
                                                                                                                        id={`mmsl_TableRow_3_${rowIndex}_${itemIndex}`}
                                                                                                                        key={row.id}
                                                                                                                        className={classes.subEquipmentTableCellStyle}
                                                                                                                    >
                                                                                                                        <TableCell id={`mmsl_TableCell_1_expand`}>
                                                                                                                            <IconButton
                                                                                                                                className={classes.expandArrowStyle}
                                                                                                                                id={`mmsl_IconButton_${rowIndex}`}
                                                                                                                                aria-label="expand row"
                                                                                                                                size="small"
                                                                                                                                onClick={() => expandSubEquipmentRow(row)}
                                                                                                                            >
                                                                                                                                {openSubEquipmentRow && expandSubEquipmentID === row.equipmentId ? (
                                                                                                                                    <KeyboardArrowDown />
                                                                                                                                ) : (
                                                                                                                                    <KeyboardArrowRight />
                                                                                                                                )}
                                                                                                                            </IconButton>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center" style={{}}>
                                                                                                                            {row.subEquipmentName}
                                                                                                                        </TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{row.subEquipmentTaskCount}</TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{Math.round(row.subEquipmentAvgStartDuration)}</TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{Math.round(row.subEquipmentAvgMaintDuration)}</TableCell>
                                                                                                                        <TableCell className={classes.subEquipmentTableCellStyle} align="center">{Math.round(row.mttr)}</TableCell>
                                                                                                                    </TableRow>
                                                                                                                    <TableRow>
                                                                                                                        {expandSubEquipmentID === row.equipmentId ? (
                                                                                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                                                                                                <Collapse in={openSubEquipmentRow} timeout="auto" unmountOnExit>
                                                                                                                                    <div style={{ width: "100%", textAlign: "center" }}>
                                                                                                                                        <DataGrid
                                                                                                                                            autoHeight={true}
                                                                                                                                            rows={subEqTaskList}
                                                                                                                                            columns={getTableColumns(false)}
                                                                                                                                            pageSize={tasksRowsPerPage}
                                                                                                                                            onPageSizeChange={tasksHandleChangeRowsPerPage}
                                                                                                                                            onPageChange={tasksHandleChangePage}
                                                                                                                                            rowsPerPageOptions={[5, 10, 20, 50]}
                                                                                                                                            rowCount={subEqTaskList.length} //total count
                                                                                                                                            page={tasksCurrentPage}
                                                                                                                                            pagination
                                                                                                                                            disableColumnFilter
                                                                                                                                            disableColumnMenu
                                                                                                                                            getRowId={(row) => row.id}
                                                                                                                                            onRowClick={(param) => {
                                                                                                                                                NavigateToDetails(param.id);
                                                                                                                                            }}
                                                                                                                                            components={{
                                                                                                                                                Toolbar: customToolbar,
                                                                                                                                                NoRowsOverlay: noRowsTemplate,
                                                                                                                                                LoadingOverlay: LinearProgress,
                                                                                                                                            }}
                                                                                                                                            loading={loading}                                                                                                                                            {...false}
                                                                                                                                            filterMode="server"
                                                                                                                                            columnVisibilityModel={columnVisibilityModel}
                                                                                                                                            onColumnVisibilityModelChange={(newModel) =>
                                                                                                                                                handleChangeVisibility(newModel)
                                                                                                                                            }
                                                                                                                                            onSortModelChange={(sortModel) => handleSort(sortModel)}
                                                                                                                                            sx={{
                                                                                                                                                boxShadow: 5,
                                                                                                                                                "& .MuiDataGrid-row:hover": {
                                                                                                                                                    color: "primary.main",
                                                                                                                                                },
                                                                                                                                                "& .MuiDataGrid-row": {
                                                                                                                                                    color: "black",
                                                                                                                                                },
                                                                                                                                                "& .MuiDataGrid-columnSeparator": {
                                                                                                                                                    display: "none",
                                                                                                                                                },
                                                                                                                                                "& .MuiTablePagination-toolbar": {
                                                                                                                                                    color: "black",
                                                                                                                                                }
                                                                                                                                            }}
                                                                                                                                            localeText={{
                                                                                                                                                toolbarColumns: t("Columns"),
                                                                                                                                                columnsPanelTextFieldLabel:
                                                                                                                                                    t("ColumnsPanelTextFieldLabel"),
                                                                                                                                                columnsPanelTextFieldPlaceholder:
                                                                                                                                                    t("ColumnsPanelTextFieldPlaceholder"),
                                                                                                                                                columnsPanelShowAllButton:
                                                                                                                                                    t("ColumnsPanelShowAllButton"),
                                                                                                                                                columnsPanelHideAllButton:
                                                                                                                                                    t("ColumnsPanelHideAllButton"),
                                                                                                                                                toolbarDensity: t("Density"),
                                                                                                                                                toolbarDensityCompact: t("DensityCompact"),
                                                                                                                                                toolbarDensityStandard: t("DensityStandard"),
                                                                                                                                                toolbarDensityComfortable: t("DensityComfortable"),
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                </Collapse>
                                                                                                                            </TableCell>
                                                                                                                        ) : null}
                                                                                                                    </TableRow>
                                                                                                                </React.Fragment>
                                                                                                            ))}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                                <TablePagination
                                                                                                    id="mmtl_SubEquipmentPagination"
                                                                                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                                                                                    component="div"
                                                                                                    count={subEquipmentData.length}
                                                                                                    rowsPerPage={subEquipmentRowsPerPage}
                                                                                                    page={subEquipmentCurrentPage}
                                                                                                    onPageChange={subEquipmentHandleChangePage}
                                                                                                    onRowsPerPageChange={subEquipmentHandleChangeRowsPerPage}
                                                                                                    className={classes.subEquipmentTableCellStyle}
                                                                                                />
                                                                                            </TableContainer>
                                                                                        </Collapse>
                                                                                    </TableCell>
                                                                                ) : null}
                                                                            </TableRow>
                                                                        </React.Fragment>
                                                                    ))}
                                                            </TableBody>
                                                        </Table>
                                                        <TablePagination
                                                            id="mmtl_MainEquipmentPagination"
                                                            rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                                            component="div"
                                                            count={mainEquipmentData.length}
                                                            rowsPerPage={mainEquipmentRowsPerPage}
                                                            page={mainEquipmentCurrentPage}
                                                            onPageChange={mainEquipmentHandleChangePage}
                                                            onRowsPerPageChange={mainEquipmentHandleChangeRowsPerPage}
                                                            className={classes.mainEquipmentTableCellStyle}
                                                        />
                                                    </TableContainer>
                                                </Collapse>
                                            </TableCell>
                                        ) : null}
                                    </TableRow>
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        id="mmtl_AreaGroupPagination"
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        component="div"
                        count={areaGroupData.length}
                        rowsPerPage={areaGrouprowsPerPage}
                        page={areaGroupCurrentPage}
                        onPageChange={areaGroupHandleChangePage}
                        onRowsPerPageChange={areaGroupHandleChangeRowsPerPage}
                        className={classes.areaTableCellStyle}
                    />
                </TableContainer>
            </Grow>
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
